import {
  ArrowDropDownRounded,
  CloseRounded,
  MenuRounded,
} from '@mui/icons-material';
import { Button, Collapse, IconButton } from '@mui/material';
import { MomentoLogo } from '@icons';
import { SwitchLocale, Login, Cart } from '@components';
import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import DrawerDesktopList from './DrawerDesktopList';
import Link from 'next/link';
import classNames from 'classnames';

export default function Navbar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [type, setType] = useState(null);
  const toggleDrawer = (newOpen, type = null) => {
    setType(type);
    setOpen(newOpen);
  };
  const linkClass = `hover:text-primary cursor-pointer`;

  return (
    <div className="bg-neutral relative top-0 flex flex-col items-start justify-start px-4 md:px-8 lg:px-16 pt-6 z-20 text-primary-950 font-medium shadow-xl w-full">
      <div className="flex items-center justify-between w-full pb-6">
        <div className="flex md:space-x-6 lg:space-x-10 xl:space-x-16 justify-start items-center w-full">
          <Button>
            <Link href={'/'}>
              <MomentoLogo className="fill-primary h-5 md:h-8 md:max-w-[20vw] max-w-full inline-block" />
            </Link>
          </Button>

          {/* Desktop navigation (visible from md and above) */}
          <div className="hidden body leading-none lg:flex justify-around items-center md:space-x-2 lg:space-x-4 xl:space-x-6">
            <Link href={'/filosofia'} className={linkClass}>
              <span>{t('navbar.philosophy')}</span>
            </Link>
            <div
              onClick={() => {
                if (!open) {
                  toggleDrawer(true, 'stores');
                } else {
                  toggleDrawer(false);
                }
              }}
              className={linkClass}
            >
              <span className="flex items-center">
                {t('navbar.locations')}

                <ArrowDropDownRounded
                  className={classNames(
                    'inline-block ml-1 ',
                    open && 'rotate-180',
                  )}
                />
              </span>
            </div>
            <Link href={'/servizi'} className={linkClass}>
              <span>{t('navbar.services')}</span>
            </Link>
            <Link href={'/eventi'} className={linkClass}>
              <p>{t('navbar.event_gallery')}</p>
            </Link>
          </div>
        </div>

        <div className="flex items-center md:space-x-1 xl:space-x-3">
          {/* Locale switcher and cart only visible on md and above */}
          <SwitchLocale className="hidden md:flex items-center" />
          <Login />
          <Cart />

          {/* Mobile menu button (visible below md) */}
          <div className="lg:hidden">
            <IconButton onClick={() => toggleDrawer(!open)}>
              {!open ? (
                <MenuRounded className="fill-primary-950" />
              ) : (
                <CloseRounded className="fill-primary-950" />
              )}
            </IconButton>
          </div>
        </div>
      </div>

      <Collapse orientation="vertical" in={open} className="w-full">
        <DrawerDesktopList
          onClose={() => toggleDrawer(false)}
          type={type}
        />
      </Collapse>
    </div>
  );
}
